import React from 'react';
import FileExist from '../components/FileExist';
import {FormGroup, FormControl} from 'react-bootstrap';
import {converteAddTimezone} from '@assets/js/helpers/date_helper';

class FileEdit extends React.Component {
    constructor(props) {
        super(props);
        this.spanStyle = {
            float: 'left',
            display: 'block',
        };
    }
    handleChangeEvent(ev) {
        let name = ev.target.name;
        let value = ev.target.value;
        this.props.changeHandler(name, value, this.props.index);
    };
    render() {
        if (this.props.filesDelIds.indexOf(this.props.id) !== -1) {
            return null;
        }
        return (
            <tr onClick={(e)=>{this.props.clickHandler(this.props.id, e)}}>
                <td className="text-center">
                    <span className="glyphicon glyphicon-option-vertical" />
                </td>
                <td className="text-center">
                    <input type="checkbox" name="file-select" value={this.props.id} />
                    <input type="hidden" name="file-id" value={this.props.id}/>
                </td>
                <td className="text-center">{this.props.sort_id}</td>
                <td>
                    <input type="text" name="title" className="form-control" placeholder="Введите подпись к файлу"
                           onChange={this.handleChangeEvent.bind(this)}
                           value={this.props.title} />
                </td>
                <td>
                    <input type="text" name="file_name" className="form-control"
                           placeholder="Введите название файла для ссылки"
                           onChange={this.handleChangeEvent.bind(this)}
                           value={this.props.file_name} />
                </td>
                {Number(this.props.settings['is_simple_signature'])
                    ? <td className="td-file-signature">
                        <FormControl componentClass="select" name="signature_id" placeholder="select" disabled={this.props.file_ext !== 'pdf'}
                                     value={Number(this.props.signature_id)} onChange={this.handleChangeEvent.bind(this)}>
                            <option value="0">Не выбрано</option>
                            {this.props.settings['signatures'].map((signature) => {
                                return (
                                    <option value={signature.id} key={signature.id}>
                                        {signature.full_name} ({signature.post})
                                    </option>
                                )
                            })}
                        </FormControl>
                        {this.props.signing_date
                            ? converteAddTimezone(this.props.signing_date, this.props.monolitSettings.timezone)
                            : null}
                    </td>
                    : null}
                <td className="td-file-status">
                    {converteAddTimezone(this.props.created_date, this.props.monolitSettings.timezone)}
                    &nbsp;
                    <FileExist fileExist={this.props.fileExist}/>
                </td>
            </tr>
        )
    }
}
export default FileEdit;
